import {SessionStorage} from '@js/SessionStorage';
import {routes} from "@js/helpers/routes";
import {sendRequest} from "@js/utils";
import {getUrlParameter, reloadWithoutGetParams} from "@js/helpers/location";

$(() => {
    clearDataFromStorage();
    loadDataToStorage(routes.vuzRyadom.regions(), 'regions');
    loadDataToStorage(routes.vuzRyadom.interests(), 'interests');
    let hashParam = getUrlParameter('hash');
    if (!hashParam) {
        const storage = new SessionStorage();
        hashParam = storage.get('hash', false);
    }
    if (hashParam) {
        showResult(hashParam);
    }
    $('.question__change-block')
        .on('click', '.change-block__input', function () {
            const header = $(this).attr('data-header');
            const description = $(this).attr('data-description');
            const placeholder = $(this).attr('data-text');
            const $modal = $('.main-body__modal');
            $modal.find('.text__main').text(header);
            $modal.find('.text__description').text(description);
            const $input = $modal.find('.body__search');
            $input.attr('placeholder', placeholder);
            if (placeholder.length === 0) {
                $input.addClass('body__search_hidden');
            }
            showModal($(this).attr('id'));
        })
        .on('click', '.change-block__clear-button', function () {
            const $currentQuestionBlock = $(this).closest('.questions-block__question');
            $currentQuestionBlock.nextAll(['.questions-block__question', '.questions-block__result']).addClass('questions-block__hidden-block');
            $currentQuestionBlock.find('.change-block__input').val('');
            $currentQuestionBlock.nextAll(['.change-block__input', 'input[type="hidden"]']).val('');
            $currentQuestionBlock.find('.tips__tip').addClass('tips__tip_default').removeClass('tips__tip_inverse');
        });
    $('.question__tips')
        .on('click', '.tips__tip', function () {
            const $tipsBlock = $(this).closest('.tips__inner');
            const $allTips = $tipsBlock.find('.tips__tip')
            $allTips.removeClass('tips__tip_inverse');
            $allTips.addClass('tips__tip_default');
            $(this).removeClass('tips__tip_default');
            $(this).addClass('tips__tip_inverse');
            loadDataAndShowNextBlock(this, false);
        });
    $('.questions-block__result')
        .on('click', '.result__button', () => {
            sendStatistic();
        });
    $('.main-body__modal')
        .on('click', '.close-section__button', function () {
            closeModal($(this));
        })
        .on('click', '.list__item', function () {
            loadDataAndShowNextBlock(this, false);
            closeModal($(this));
        })
        .on('input', '.body__search', function () {
            const searchVal = $(this).val().toLowerCase();
            const $listItems = $('.list__item');
            if (searchVal === '') {
                $listItems.removeClass('list__item_hidden');
            } else {
                $listItems.each((index, item) => {
                    const itemValue = $(item).text().toLowerCase();
                    if (itemValue.includes(searchVal)) {
                        $(item).removeClass('list__item_hidden');
                    } else {
                        $(item).addClass('list__item_hidden');
                    }
                });
            }
        });
    $('.vuzRyadom-body__result')
        .on('click', '.reload, .noresult__link', () => {
            const storage = new SessionStorage();
            storage.remove('hash');
            reloadWithoutGetParams();
        })
        .on('click', '.item__share', () => {
            let el = $('.buttons-block__share');
            if (el.hasClass('buttons-block__share_hidden')) {
                el.removeClass('buttons-block__share_hidden').addClass('buttons-block__share_visible');
            } else {
                el.removeClass('buttons-block__share_visible').addClass('buttons-block__share_hidden');
            }
        })
        .on('click', '.tab-button', function () {
            $('.tab-button').removeClass('active');
            let currentClass = $(this).attr('class');
            const currentClassArr = currentClass.split(' ');
            currentClass = '.' + currentClassArr.join('.');
            const isHome = $(this).hasClass('home');
            const $saveImgBtn = $('.saveImage')
            const oldImageLink = $saveImgBtn.attr('href');
            const newImageLink = $(this).attr('data-image-link');
            $saveImgBtn.attr('href', newImageLink);
            const $vkBtn = $('.vk-btn');
            let vkLink = $vkBtn.attr('href');
            vkLink = vkLink.replace(oldImageLink, newImageLink);
            $vkBtn.attr('href', vkLink);
            const $vuzBlocks = $('.share-card-block');
            $vuzBlocks.show();
            let counter = 1;
            $vuzBlocks.each((index, item) => {
                if (isHome && !$(item).hasClass('share-card-block_current-region')) {
                    $(item).hide();
                } else {
                    $(item).find('p.top__text').text('Топ-' + counter++);
                }
            });
            if (counter === 1) {
                $('.noresult').removeClass('noresult_hidden');
            } else {
                $('.noresult').addClass('noresult_hidden');
            }
            if (counter > 3) {
                $('.bottom-share-panel').show();
            } else {
                $('.bottom-share-panel').hide();
            }
            $(currentClass).addClass('active');
        });
});

function closeModal($element) {
    $('.body__list').scrollTop(0);
    $element.closest('.main-body__modal').addClass('main-body__modal_hidden');
    $('.main-body__modal').find('.body__search').removeClass('body__search_hidden');
}

function showModal(id) {
    const $modal = $('.main-body__modal');
    $modal.find('.body__search').val('');
    let listArr = [], key = '', value = '', type = '';
    switch (id) {
        case 'region-text':
            listArr = getDataFromStorage('regions');
            key = 'kod';
            value = 'name';
            type = 'region';
            break;
        case 'interest-text':
            listArr = getDataFromStorage('interests');
            key = 'interest_id';
            value = 'interest_name';
            type = 'interest';
            break;
        case 'subject-text':
            listArr = getDataFromStorage('naprs');
            key = 'id';
            value = 'name';
            type = 'subject';
    }
    const $listBlock = $modal.find('.body__list');
    $listBlock.empty();
    listArr.forEach((item) => {
        $listBlock.append('<li class="list__item" data-type="' + type + '" data-value="' + item[key] + '">' + item[value] + '</li>');
    });
    $modal.removeClass('main-body__modal_hidden');
    $modal.css('animation-name', 'show-modal');
}

async function loadDataToStorage(url, key, id = 0) {
    await sendRequest('get', url, '', (res) => {
        if (res?.success) {
            const storage = new SessionStorage();
            storage.set(key, res[key]);
        }
    });
}

function getDataFromStorage(key, isObject = true) {
    const storage = new SessionStorage();
    return storage.get(key, isObject);
}

function clearDataFromStorage() {
    const storage = new SessionStorage();
    storage.remove('regions');
    storage.remove('interests');
    storage.remove('interestTips');
    storage.remove('naprs');
    storage.remove('naprTips');
}

function loadDataAndShowNextBlock(changeBlock, isCurrentBlock = true) {
    const hiddenElementId = $(changeBlock).attr('data-type');
    const elementId = hiddenElementId + '-text';
    const $hiddenElement = $(`input[name="${hiddenElementId}"]`);
    const hiddenElementVal = $(changeBlock).attr('data-value');
    const $questionBlock = $hiddenElement.closest('.questions-block__question');
    const $nextQuestionBlock = $questionBlock.next();
    let route = '', storageKey = '', type = '', itemIdKey = '', itemValueKey = '';
    switch (hiddenElementId) {
        case 'region':
            route = routes.vuzRyadom.interestTips(parseInt(hiddenElementVal));
            storageKey = 'interestTips';
            type = 'interest';
            itemIdKey = 'interest_id';
            itemValueKey = 'interest_name';
            break;
        case 'interest':
            loadDataToStorage(routes.vuzRyadom.naprs(parseInt(hiddenElementVal)), 'naprs');
            route = routes.vuzRyadom.naprTips($(`input[name="region"]`).val(), parseInt(hiddenElementVal));
            storageKey = 'naprTips';
            type = 'subject';
            itemIdKey = 'id';
            itemValueKey = 'name';
            $nextQuestionBlock.find('.change-block__input').val('');
            $nextQuestionBlock.find('input[type="hidden"]').val('');
            $nextQuestionBlock.nextAll(['.questions-block__result']).addClass('questions-block__hidden-block');
    }
    $nextQuestionBlock.removeClass('questions-block__hidden-block');
    const $tipsBlock = $nextQuestionBlock.find('.tips__inner');
    loadDataToStorage(route, storageKey).then(() => {
        $tipsBlock.empty();
        const tips = getDataFromStorage(storageKey);
        tips.forEach((item) => {
            $tipsBlock.append('<div class="tips__tip tips__tip_default" data-type = "' + type + '" data-value="' + item[itemIdKey] + '">' + item[itemValueKey] + '</li>');
        });
    });
    $(`#${elementId}`).val($(changeBlock).text());
    $hiddenElement.val(hiddenElementVal);
    $hiddenElement.closest('.questions-block__question').find('.tips__tip').each((index, item) => {
        const tipsValue = $(item).attr('data-value');
        if (hiddenElementVal === tipsValue) {
            $(item).removeClass('tips__tip_default');
            $(item).addClass('tips__tip_inverse');
        } else {
            $(item).removeClass('tips__tip_inverse');
            $(item).addClass('tips__tip_default');
        }
    })
}

function sendStatistic() {
    const regionKod = $('input[name="region"]').val();
    const interestId = $('input[name="interest"]').val();
    const naprId = $('input[name="subject"]').val();
    const updateStatisticUrl = routes.vuzRyadom.updateStatistics(regionKod, interestId, naprId);
    loadDataToStorage(updateStatisticUrl, 'hash').then(() => {
        const hash = getDataFromStorage('hash', false);
        showResult(hash);
    });
}

function showResult(hash) {
    const $mainBody = $('.main-body');
    $mainBody.css('position', 'relative');
    const $loading = $('.main-body__loading');
    $loading.removeClass('main-body__loading_hidden');
    const $formBlock = $('.vuzRyadom-body__form');
    const $resultBlock = $('.vuzRyadom-body__result');
    let response = false;
    sendRequest('get', routes.vuzRyadom.showResult(hash), '', (res) => {
        response = res?.success;
        if (response) {
            $resultBlock.html(res.html);
            const metaContent = res.metaContent;
            for (const key in metaContent) {
                const $metaTag = $(`metakey[property="${key}"]`);
                if ($metaTag.length > 0) {
                    $metaTag.attr('content', metaContent[key])
                } else {
                    $('head').append(`<meta property="${key}" content="${metaContent[key]}">`);
                }
            }
            const imageLinks = res.shareImgLinks;
            $('.vk-btn').attr('href', `https://vk.com/share.php?url=${metaContent['og:url']}&title=${metaContent['og:title']}&image=${imageLinks.general}`);
            $('.tg-btn').attr('href', `https://telegram.me/share/url?url=${metaContent['og:url']}&text=${metaContent['og:title']}`);
            $('.wa-btn').attr('href', `https://api.whatsapp.com/send/?text=${metaContent['og:title']}+Подробнее:+${metaContent['og:url']}`);
            $('.saveImage').attr('href', imageLinks.general);
            $('.here').attr('data-image-link', imageLinks.general);
            $('.home').attr('data-image-link', imageLinks.region);
            $('.header__image-info').tooltip({
                animated: 'fade',
                placement: 'left',
                trigger: 'click',
                title: 'В основе сервиса лежит Предметный национальный агрегированный рейтинг (<a target="_blank" href="' + routes.public.rankings.pnar() + '">ссылка</a>)',
                html: true
            });
        } else {
            $formBlock.show();
        }
    })
    setTimeout(function load() {
        if (typeof response !== 'undefined') {
            if (response) {
                $formBlock.hide();
                $mainBody.css('position', 'static');
                $loading.addClass('main-body__loading_hidden');
            } else {
                setTimeout(load, 3000);
            }
        } else {
            $formBlock.show();
            $mainBody.css('position', 'static');
            $loading.addClass('main-body__loading_hidden');
        }
    }, 3000);
}


